import { render, staticRenderFns } from "./sale-order-request.vue?vue&type=template&id=ab6d2bfa&"
import script from "./sale-order-request.vue?vue&type=script&lang=ts&"
export * from "./sale-order-request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports